export default __webpack_public_path__ + "static/media/noa-5.6016b320.jpg";